import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from '../../../pages/pages/subscription/subscription.service';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';
import { getRegionCurrency } from '../../../../global.variable';
@Component({
  selector: 'gtapp-reserved-user-billing-details',
  standalone: false,
  templateUrl: './reserved-user-billing-details.component.html',
  styleUrl: './reserved-user-billing-details.component.scss',
})
export class ReservedUserBillingDetailsComponent implements OnInit {
  reservedBillingDetails: any;
  regionCurrencySymbol = getRegionCurrency(true);

  constructor(
    private subscriptionService: SubscriptionService,
    protected dialogueRef: DialogRef,
  ) {}

  ngOnInit() {
    this.subscriptionService
      .getSubscriberSubscriptionStatus({ get_reserve_billing_details: 1 })
      .subscribe((response: any) => {
        this.reservedBillingDetails = response?.data;
      });
  }
  onDismiss(): void {
    // Close the dialog, return false
    this.dialogueRef.close(false);
  }
}
